import { useState, useEffect } from 'react';

export default function CouponPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup
    const hasSeenPopup = localStorage.getItem('couponPopupSeen');
    
    if (!hasSeenPopup) {
      // Show popup after 1 second with fade-in animation
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      localStorage.setItem('couponPopupSeen', 'true');
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <>
      {isVisible && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-40 animate-fade-in">
          <div className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-lg shadow-2xl p-6 max-w-md mx-4 relative"
            style={{
              backgroundImage: `linear-gradient(to right, rgba(8, 145, 178, 0.95), rgba(37, 99, 235, 0.95)), url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0c0 10-10 20-20 20S0 10 0 0h10c0 5.523 4.477 10 10 10s10-4.477 10-10h10zm0 20c10 0 20 10 20 20s-10 20-20 20-20-10-20-20h10c0 5.523 4.477 10 10 10s10-4.477 10-10 10-4.477 10-10h-10z' fill='%23ffffff' fill-opacity='0.08'/%3E%3C/svg%3E")`,
              backgroundSize: 'cover'
            }}
          >
            <button 
              onClick={handleClose}
              className="absolute top-2 right-2 text-white hover:text-gray-200 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl w-6 h-6 flex items-center justify-center"></i>
            </button>
            
            <div className="text-center">
              <div className="mb-4">
                <i className="ri-gift-line text-5xl w-12 h-12 flex items-center justify-center mx-auto"></i>
              </div>
              <h3 className="text-2xl font-bold mb-2">Special Offer!</h3>
              <p className="text-lg mb-4">Get 25% OFF on orders over $150</p>
              <div className="bg-white text-cyan-700 py-3 px-6 rounded-lg inline-block font-bold text-xl mb-4">
                SAVE25
              </div>
              <p className="text-sm text-cyan-100">Use code at checkout</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
